import React from "react";
import { MethodBadge } from "./Methodbadge";

interface EndpointHeaderProps {
  method: string;
  url: string;
}

export const EndpointHeader: React.FC<EndpointHeaderProps> = ({ method, url }) => (
  <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 mt-4 font-mono text-sm">
    <MethodBadge method={method} />
    <span className="text-gray-700">{url}</span>
  </div>
);